var map = {
	"./BAG_grab.mp3": 63851,
	"./Cat.mp3": 69446,
	"./Close_Door.mp3": 1653,
	"./DOOR_Close-01.mp3": 47725,
	"./DOOR_Close-02.mp3": 28098,
	"./DOOR_Close-03.mp3": 85159,
	"./DOOR_Open-01.mp3": 67608,
	"./DOOR_Open-02.mp3": 93943,
	"./DOOR_Open-03.mp3": 33610,
	"./ELEVATOR_Open.mp3": 99908,
	"./FIRE_High.mp3": 21774,
	"./FIRE_Low.mp3": 16783,
	"./FIRE_Mid.mp3": 47051,
	"./FIRE_Position-High.mp3": 10138,
	"./FIRE_Position-Low.mp3": 63294,
	"./FIRE_Position-Mid.mp3": 76234,
	"./Fire.mp3": 33058,
	"./Fire_Alarm.mp3": 7399,
	"./Intro_Ambient.mp3": 65760,
	"./Music_level_1.mp3": 82599,
	"./Music_level_2.mp3": 66567,
	"./Music_level_3.mp3": 36023,
	"./Notification.mp3": 85098,
	"./Open_Door.mp3": 71448,
	"./Open_Window.mp3": 45564,
	"./PHONE_911.mp3": 35163,
	"./SMOKE.mp3": 72017,
	"./Siren.mp3": 10543,
	"./Towel.mp3": 9424,
	"./UI_ACTION_Success.mp3": 69193,
	"./UI_ACTION_fail.mp3": 39141,
	"./UI_CLICK_Main.mp3": 10117,
	"./UI_CLICK_Secondary.mp3": 20291,
	"./UI_GAME-OVER.mp3": 22231,
	"./UI_GAME-SUCCESS.mp3": 92342,
	"./UI_HOTSPOT.mp3": 19006,
	"./UI_HOVER.mp3": 6737,
	"./UI_POP-IN.mp3": 25957,
	"./UI_SAY-HELLO.mp3": 2828,
	"./UI_SYNC_Ko.mp3": 71926,
	"./UI_SYNC_Ok.mp3": 33872,
	"./WINDOW_Open-01.mp3": 88280,
	"./WINDOW_Open-02.mp3": 56094,
	"./WINDOW_Open-03.mp3": 78646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48215;